/* PrimerDeck theme JS (04-09-2026 speed pass). Verplaatst uit layout/theme.liquid (18 KB head + 71 KB body
   inline) naar dit uitgestelde bestand: cachebaar over pagina's, niet parser-blokkerend. Liquid-waarden
   komen uit window.pdCfg (klein inline blok in theme.liquid). Volgorde en inhoud van de code ongewijzigd. */
(function(){
  var pdCfg = window.pdCfg || { root: '/', collectionsUrl: '/collections', cust: null, serverList: null, factsLabel: '16 languages · Instant PDF download' };
/* ===== deel 1: voormalig head-script ===== */

      // This script runs from <head>: document.body does not exist yet.
      // Any init that touches the DOM immediately must go through pdOnReady.
      function pdOnReady(fn) {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', fn);
        } else {
          fn();
        }
      }
      // Sticky header shadow + scroll velocity tracker for marquee
      // Only flips body class while actively driving the marquee speed.
      // When idle, the per-section speed setting from the customizer wins.
      // 03-09 scroll-fix: alleen nog de is-scrolled-klasse, en alleen schrijven bij een
      // echte wissel. De oude --pd-scroll-velocity op <html> (bij elke scrollstap) dwong
      // een volledige herstyling van de pagina af; dat was de hapering in Safari.
      if (!('requestIdleCallback' in window)) {
        window.requestIdleCallback = function (cb) { return setTimeout(function () { cb({ didTimeout: false, timeRemaining: function () { return 50; } }); }, 1); };
        window.cancelIdleCallback = function (id) { clearTimeout(id); };
      }
      let pdScrolledState = null;
      document.addEventListener('scroll', () => {
        const s = window.scrollY > 40;
        if (s !== pdScrolledState) { pdScrolledState = s; document.body.classList.toggle('is-scrolled', s); }
      }, { passive: true });

      // PrimerDeck wow-effects: word reveal + scroll-velocity marquee + magnetic CTAs
      document.addEventListener('DOMContentLoaded', () => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // 1) Wrap each word in jumbo + key headings into <span class="pd-word"> for stagger reveal
        if (!reduceMotion) {
          const wrapWords = (el) => {
            if (el.dataset.pdWordsWrapped) return;
            el.dataset.pdWordsWrapped = '1';
            const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
            const nodes = [];
            let n;
            while ((n = walker.nextNode())) nodes.push(n);
            nodes.forEach((textNode) => {
              const text = textNode.nodeValue;
              if (!text.trim()) return;
              const frag = document.createDocumentFragment();
              text.split(/(\s+)/).forEach((part) => {
                if (/^\s+$/.test(part)) {
                  frag.appendChild(document.createTextNode(part));
                } else if (part.length) {
                  const span = document.createElement('span');
                  span.className = 'pd-word';
                  span.textContent = part;
                  frag.appendChild(span);
                }
              });
              textNode.parentNode.replaceChild(frag, textNode);
            });
            const words = el.querySelectorAll('.pd-word');
            words.forEach((w, i) => {
              w.style.setProperty('--pd-word-i', i);
            });
          };

          // Hero jumbo — instant reveal on load
          document.querySelectorAll('[class*="pd-hero-"] .pd-jumbo, [class*="pd-cta-"] .pd-jumbo').forEach(wrapWords);

          // Big section headings — reveal on scroll into view
          const headingSelectors = [
            '[class*="primerdeck-columns-"] .pd-heading',
            '[class*="pd-compare-"] .pd-heading',
            '[class*="pd-story-"] .pd-heading',
            '[class*="pd-colcards-"] .pd-heading',
            '[class*="pd-stats-"] .pd-heading',
            '[class*="pd-testim-"] .pd-heading',
            '[class*="pd-faq-"] .pd-heading',
          ].join(',');
          document.querySelectorAll(headingSelectors).forEach(wrapWords);
        }

        if (window.matchMedia('(hover: none)').matches) return;

        document.querySelectorAll('[class*="pd-hero-"]').forEach(hero => {
          hero.addEventListener('mousemove', (e) => {
            const rect = hero.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            hero.style.setProperty('--mx', x + '%');
            hero.style.setProperty('--my', y + '%');
          });
        });

        // Magnetic CTAs — subtle pull toward cursor
        document.querySelectorAll('[class*="pd-hero-"] .pd-btn--primary, [class*="pd-cta-"] .pd-submit').forEach(btn => {
          btn.addEventListener('mousemove', (e) => {
            const rect = btn.getBoundingClientRect();
            const cx = rect.left + rect.width / 2;
            const cy = rect.top + rect.height / 2;
            const dx = (e.clientX - cx) * 0.18;
            const dy = (e.clientY - cy) * 0.18;
            btn.style.transform = `translate(${dx}px, ${dy}px)`;
          });
          btn.addEventListener('mouseleave', () => {
            btn.style.transform = '';
          });
        });
      });

      // Stats count-up + live counter
      document.addEventListener('DOMContentLoaded', () => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const formatNum = (n, isLive) => {
          n = Math.floor(n);
          return n >= 1000 ? n.toLocaleString('en-US') : String(n);
        };

        const setNumber = (el, n, suffix) => {
          el.innerHTML = formatNum(n) + (suffix ? suffix.outerHTML : '');
        };

        // Smooth count-up from `from` to `to` over `duration` ms
        const animateTo = (el, from, to, duration, suffix) => {
          if (from === to) { setNumber(el, to, suffix); return; }
          const start = performance.now();
          const step = (now) => {
            const t = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - t, 3);
            const current = from + (to - from) * eased;
            setNumber(el, current, suffix);
            if (t < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        };

        document.querySelectorAll('.pd-stat-number').forEach(numEl => {
          const stat = numEl.closest('.pd-stat');
          const isLive = stat && stat.dataset.pdLive === '1';
          numEl.dataset.pdInitial = numEl.textContent.trim().replace(/[^\d]/g, '');
          numEl.dataset.pdCurrent = '0';
        });
      });

      // L1-fix (audit 28-08): sluimerende live-teller-fabricage (mulberry32,
      // dagcyclus-sinus) VERWIJDERD. Verzonnen cijfers blijven verboden;
      // dode machinerie mag nooit per ongeluk geactiveerd kunnen worden.

      // Hero-parallax TERUGGEZET (operator, aug 2026): geeft de lijnen hun
      // 3D-gelaagdheid doordat de patroonlaag trager meebeweegt dan de tekst.
      // Was eerder verdacht bij de witte-waas-jacht, maar de echte oorzaak
      // bleek de klassenaam-botsing op de body (pd-marquee-driving).
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let pdParallaxQueued = false;
        document.addEventListener('scroll', () => {
          if (pdParallaxQueued) return;
          pdParallaxQueued = true;
          requestAnimationFrame(() => {
            pdParallaxQueued = false;
            const heroBgs = document.querySelectorAll('[class*="pd-hero-"] .pd-bg .pd-svg-pattern, [class*="pd-hero-"] .pd-bg img');
            const y = window.scrollY;
            heroBgs.forEach(img => {
              if (y < window.innerHeight) {
                img.style.transform = `translateY(${y * 0.22}px)`;
              }
            });
          });
        }, { passive: true });
      }

      // M-1 — Auto-attach loading state to forms on submit
      // Adds aria-busy="true" to the submit button; CSS swaps label for spinner.
      // Removes it after 8s as a safety (Shopify usually reloads the page first).
      document.addEventListener('submit', (e) => {
        const form = e.target;
        if (!form || !(form instanceof HTMLFormElement)) return;
        // Skip if form opts out via data-pd-no-loading
        if (form.dataset.pdNoLoading === '1') return;
        // Horizon product forms manage their own submit lifecycle. This
        // capture listener runs BEFORE the component's delegated handleSubmit;
        // disabling the button here makes #processAddToCart bail out
        // (anyButtonDisabled guard) — add-to-cart silently did nothing.
        if (form.closest('product-form-component')) return;
        const submits = form.querySelectorAll(
          'button[type="submit"], input[type="submit"], button:not([type])'
        );
        submits.forEach((btn) => {
          btn.setAttribute('aria-busy', 'true');
          btn.setAttribute('data-pd-loading-original', btn.disabled ? '1' : '0');
          btn.disabled = true;
        });
        setTimeout(() => {
          submits.forEach((btn) => {
            btn.removeAttribute('aria-busy');
            if (btn.dataset.pdLoadingOriginal === '0') btn.disabled = false;
            btn.removeAttribute('data-pd-loading-original');
          });
        }, 8000);
      }, { capture: true });

      // H2-fix (audit 28-08): custom mobiele sticky-ATC-kloon (M-6) VERWIJDERD.
      // Dupliceerde element-id's en stond tegelijk met pdStickyProductBar en
      // Horizon's eigen sticky ATC op het scherm. Native gedrag blijft.

      // M-10 — Cookie consent banner (GDPR-compliant + accept-optimised)
      // Wired to Shopify Customer Privacy API so Meta Pixel + analytics
      // respect the choice. 1.5s delay to let the page settle first.
      (function pdCookieBanner() {
        try {
          if (localStorage.getItem('pd-cookie-consent')) return;
        } catch (_) {}

        // Set tracking consent through Shopify's Customer Privacy API.
        // This is what Meta Pixel + GA4 + Shopify analytics actually listen to.
        function setTrackingConsent(accept) {
          const apply = () => {
            try {
              if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
                window.Shopify.customerPrivacy.setTrackingConsent({
                  analytics: accept,
                  marketing: accept,
                  preferences: accept,
                  sale_of_data: accept
                }, function () { /* applied */ });
              }
            } catch (_) {}
          };
          if (window.Shopify && window.Shopify.loadFeatures) {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], apply);
          } else {
            apply();
          }
        }

        // Shopify's native privacy banner (store setting) already asks for
        // consent — showing two banners stacked is worse than one. Yield when
        // the native banner is on screen, or when the visitor already answered
        // it (consent recorded via the Customer Privacy API, which must be
        // loaded before it can be read).
        function nativeConsentHandled(cb) {
          if (document.querySelector('[id^="shopify-pc__"]')) return cb(true);
          const check = () => {
            try {
              const cp = window.Shopify && window.Shopify.customerPrivacy;
              if (cp && typeof cp.currentVisitorConsent === 'function') {
                const c = cp.currentVisitorConsent();
                return cb(!!(c && (c.analytics || c.marketing || c.preferences || c.sale_of_data)));
              }
            } catch (_) {}
            cb(false);
          };
          if (window.Shopify && window.Shopify.loadFeatures) {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], check);
          } else {
            check();
          }
        }

        function buildBanner() {
          const banner = document.createElement('div');
          banner.className = 'pd-cookie-banner';
          banner.setAttribute('role', 'dialog');
          banner.setAttribute('aria-labelledby', 'pd-cookie-title');
          banner.setAttribute('aria-describedby', 'pd-cookie-text');
          banner.innerHTML = `
            <div>
              <span class="pd-cookie-banner__kicker" id="pd-cookie-title">A QUICK NOTE</span>
              <p class="pd-cookie-banner__text" id="pd-cookie-text">
                <strong>Cookies on for the full experience.</strong> They remember your cart, keep the site fast, and help us send the next free guide to the right inbox. <a href="' + pdCfg.root + 'pages/cookie-policy">Read more</a>.
              </p>
            </div>
            <div class="pd-cookie-banner__actions">
              <button type="button" class="pd-cookie-banner__btn--accept" data-pd-cookie="accept" autofocus>
                Yes, sounds good
              </button>
              <button type="button" class="pd-cookie-banner__btn--decline" data-pd-cookie="decline">
                Essential cookies only
              </button>
            </div>
          `;
          document.body.appendChild(banner);
          requestAnimationFrame(() => banner.setAttribute('data-pd-shown', '1'));

          banner.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-pd-cookie]');
            if (!btn) return;
            const choice = btn.dataset.pdCookie;
            const accept = (choice === 'accept');
            try {
              localStorage.setItem('pd-cookie-consent', JSON.stringify({
                choice,
                analytics: accept,
                marketing: accept,
                ts: new Date().toISOString()
              }));
            } catch (_) {}
            setTrackingConsent(accept);
            banner.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
            banner.style.opacity = '0';
            banner.style.transform = 'translateY(20px)';
            setTimeout(() => banner.remove(), 320);
            document.dispatchEvent(new CustomEvent('pd:cookie-consent', {
              detail: { choice, accept }
            }));
          });
        }

        // 1.5s delay — let the page paint first; conversion data shows
        // delayed banners get higher accept rates than instant ones.
        setTimeout(() => nativeConsentHandled((handled) => { if (!handled) buildBanner(); }), 1500);
      })();

      // GA4 / Meta Pixel / GTM event dispatch hooks
      // Listens for Shopify analytics events (Web Pixels API) AND falls back
      // to DOM-event interception so dataLayer fires even without configured pixels.
      pdOnReady(function pdAnalyticsHooks() {
        window.dataLayer = window.dataLayer || [];
        function pushEvent(name, payload) {
          try {
            window.dataLayer.push({ event: name, ...payload, ts: Date.now() });
            document.dispatchEvent(new CustomEvent('pd:track', { detail: { name, payload } }));
          } catch (_) {}
        }

        // Add to cart — fired on any form submission to /cart/add
        document.addEventListener('submit', (e) => {
          const form = e.target;
          if (!form || !form.action || !form.action.includes('/cart/add')) return;
          const id = form.querySelector('[name="id"]')?.value;
          const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
          pushEvent('add_to_cart', { variant_id: id, quantity: qty });
        }, { capture: true });

        // View item — fired once per product page on load
        if (document.body.classList.contains('template-product')) {
          const titleEl = document.querySelector('h1.product-title, [class*="product-information"] h1, .product__title h1');
          pushEvent('view_item', {
            page_path: location.pathname,
            item_name: titleEl ? titleEl.textContent.trim() : null
          });
        }

        // Begin checkout — fired when /checkout link clicked
        document.addEventListener('click', (e) => {
          const a = e.target.closest('a[href*="/checkout"], button[name="checkout"], button[name="add"][type="submit"][formaction*="checkout"]');
          if (a) pushEvent('begin_checkout', { source: 'cart' });
        });

        // Newsletter subscribe — fired when CTA form submits
        document.addEventListener('submit', (e) => {
          const f = e.target;
          if (f && f.matches && (f.matches('[class*="pd-cta-"] form') || f.id === 'NewsletterForm' || f.action?.includes('contact'))) {
            pushEvent('newsletter_signup', { location: f.id || 'cta' });
          }
        }, { capture: true });
      });

      // Lazy image: remove blur placeholder when image actually loads
      document.addEventListener('load', (e) => {
        const t = e.target;
        if (t && t.tagName === 'IMG' && t.getAttribute('loading') === 'lazy') {
          t.removeAttribute('data-pd-loading');
          t.style.background = '';
        }
      }, { capture: true });

      // pdCursor (cursor-follower dot) is verwijderd: het 32px multiply-blobje
      // achter menu-items/links las als een kapotte hover-state en de rustende
      // dot als zwevende punt op de pagina.

      // Cart bubble — wobble animation when item added
      pdOnReady(function pdCartBubbleWobble() {
        const bubble = document.querySelector('.cart-icon-bubble, [class*="cart-bubble"], cart-icon-bubble');
        if (!bubble) return;
        document.addEventListener('pd:track', (e) => {
          if (e.detail && e.detail.name === 'add_to_cart') {
            bubble.setAttribute('data-pd-cart-bumped', '1');
            setTimeout(() => bubble.removeAttribute('data-pd-cart-bumped'), 700);
          }
        });
      });

      // 13-09 (doc 78 §19.1 d): hier stond een leestijdschatting ("N MIN READ") die op elk
      // journaalartikel werd geplakt, in het Engels in alle talen. Nergens leestijd is de eis
      // van de operator, dus dit is weg.


    
/* ===== deel 2: voormalig body-script ===== */

      // Toast helper exposed globally
      window.pdToast = function(message, type) {
        const t = document.getElementById('pd-toast');
        if (!t) return;
        t.classList.remove('pd-toast--error');
        if (type === 'error') t.classList.add('pd-toast--error');
        t.textContent = message;
        t.setAttribute('data-pd-shown', '1');
        clearTimeout(window.__pdToastTimer);
        window.__pdToastTimer = setTimeout(() => t.removeAttribute('data-pd-shown'), 3200);
      };

      // Toast fires automatically on add-to-cart success (uses our pd:track event)
      document.addEventListener('pd:track', (e) => {
        if (e.detail && e.detail.name === 'add_to_cart') {
          window.pdToast('Added to cart', 'success');
        }
        if (e.detail && e.detail.name === 'newsletter_signup') {
          window.pdToast('Thanks, check your inbox', 'success');
        }
      });

      // Cart drawer free-shipping progress bar
      // Reads cart total from data, updates progress bar with threshold target.
      // M1-fix (audit 28-08): pdShippingProgress VERWIJDERD - 'free shipping'
      // hoort niet bij een winkel met uitsluitend digitale downloads, en de
      // drawer-selector matchte sowieso nooit (.drawer__inner bestaat niet).

      // H2-fix (audit 28-08): pdStickyProductBar VERWIJDERD (dubbele sticky laag).

      // Scroll percentage CSS variable (powers back-to-top conic-gradient)
      (function pdScrollPct() {
        // 03-09 scroll-fix: de variabele stond op <html> en werd bij elke scrollstap
        // gezet = volledige herstyling per stap. Nu alleen op de knop zelf, 1x per frame,
        // en de body-klasse alleen bij een echte wissel.
        const btn = document.querySelector('.pd-back-to-top');
        let queued = false, deep = null;
        function update() {
          queued = false;
          const y = window.scrollY;
          if (btn) {
            const max = document.documentElement.scrollHeight - window.innerHeight;
            const pct = max > 0 ? Math.min(100, (y / max) * 100) : 0;
            btn.style.setProperty('--pd-scroll-pct', pct.toFixed(1));
          }
          const d = y > 400;
          if (d !== deep) { deep = d; document.body.classList.toggle('is-scrolled-deep', d); }
        }
        document.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
        update();
      })();

      // Recently viewed strip — tracks product visits in localStorage
      (function pdRecentlyViewed() {
        const KEY = 'pd-recently-viewed';
        const MAX = 6;

        function readList() {
          try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
          catch (_) { return []; }
        }
        function writeList(list) {
          try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (_) {}
        }

        // Track current product page
        if (document.body.classList.contains('template-product')) {
          const titleEl = document.querySelector('h1.product-title, [class*="product-information"] h1');
          const imgEl = document.querySelector('.product-media img, [class*="product-media-gallery"] img');
          // 02-09 audit P1-8: eerst de actuele (sale) prijs, anders werd de doorgestreepte prijs onthouden
          const priceEl = document.querySelector('.price__sale .price-item--sale, .price-item--sale, .price__current, .price__regular .price-item, .price-item--regular');
          if (titleEl) {
            const item = {
              url: location.pathname,
              name: titleEl.textContent.trim(),
              image: imgEl ? imgEl.src : '',
              price: priceEl ? priceEl.textContent.trim() : '',
              ts: Date.now()
            };
            let list = readList().filter(x => x.url !== item.url);
            list.unshift(item);
            list = list.slice(0, MAX);
            writeList(list);
          }
        }

        // Render strip on collection + product (excluding current)
        function render() {
          if (!document.body.classList.contains('template-product') &&
              !document.body.classList.contains('template-collection')) return;
          const list = readList().filter(x => x.url !== location.pathname);
          if (list.length === 0) return;
          if (document.querySelector('.pd-recently-viewed')) return;

          const strip = document.createElement('section');
          strip.className = 'pd-recently-viewed';
          // L5-fix (audit 28-08): geen string-interpolatie van localStorage-data
          // in innerHTML; DOM-bouw met textContent voorkomt kapotte attributen
          // (en injectie) bij quotes in titels.
          strip.innerHTML = `
            <div class="pd-recently-viewed__inner">
              <p class="pd-recently-viewed__kicker">RECENTLY VIEWED</p>
              <h2 class="pd-recently-viewed__title">${(window.pdCfg && pdCfg.i18n && pdCfg.i18n.recent_title) || "Where you've been."}</h2>
              <div class="pd-recently-viewed__grid"></div>
            </div>
          `;
          const grid = strip.querySelector('.pd-recently-viewed__grid');
          list.forEach(item => {
            const a = document.createElement('a');
            a.className = 'pd-recently-viewed__item';
            a.href = item.url;
            const imgWrap = document.createElement('div');
            imgWrap.className = 'pd-recently-viewed__image';
            if (item.image) {
              const img = document.createElement('img');
              img.src = item.image;
              img.alt = item.name || '';
              img.loading = 'lazy';
              // 13-09 (onderzoek C punt 9): zonder maten kon de pagina schuiven zodra deze kaften
              // laadden. Alle kaften zijn 1696 bij 2528; de vaste verhouding reserveert de ruimte
              // voordat het beeld er is (zie ook de aspect-ratio in de CSS).
              img.width = 1696; img.height = 2528;
              imgWrap.appendChild(img);
            }
            a.appendChild(imgWrap);
            const nameP = document.createElement('p');
            nameP.className = 'pd-recently-viewed__name';
            nameP.textContent = item.name || '';
            a.appendChild(nameP);
            if (item.price) {
              const priceP = document.createElement('p');
              priceP.className = 'pd-recently-viewed__price';
              priceP.textContent = item.price;
              a.appendChild(priceP);
            }
            grid.appendChild(a);
          });
          // Insert before footer
          const footer = document.querySelector('footer');
          if (footer && footer.parentNode) {
            footer.parentNode.insertBefore(strip, footer);
          } else {
            document.body.appendChild(strip);
          }
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', render);
        } else {
          render();
        }
      })();

      // Cookie preferences modal — granular toggles for analytics + marketing
      (function pdCookieModal() {
        // Add "Manage preferences" link to existing cookie banner once it builds
        const bannerCheck = setInterval(() => {
          const banner = document.querySelector('.pd-cookie-banner');
          if (!banner) return;
          if (banner.querySelector('.pd-cookie-banner__manage')) {
            clearInterval(bannerCheck);
            return;
          }
          const manageLink = document.createElement('button');
          manageLink.type = 'button';
          manageLink.className = 'pd-cookie-banner__manage';
          manageLink.textContent = 'Manage preferences';
          manageLink.addEventListener('click', openModal);
          // Insert into actions area (below decline button)
          const actions = banner.querySelector('.pd-cookie-banner__actions');
          if (actions) actions.appendChild(manageLink);
          clearInterval(bannerCheck);
        }, 200);
        setTimeout(() => clearInterval(bannerCheck), 8000);

        function openModal() {
          // Build modal once
          let modal = document.querySelector('.pd-cookie-modal');
          if (!modal) {
            modal = document.createElement('div');
            modal.className = 'pd-cookie-modal';
            modal.setAttribute('role', 'dialog');
            modal.setAttribute('aria-labelledby', 'pd-cookie-modal-title');
            modal.innerHTML = `
              <div class="pd-cookie-modal__panel">
                <span class="pd-cookie-modal__kicker">PREFERENCES</span>
                <h2 class="pd-cookie-modal__title" id="pd-cookie-modal-title">Choose what's on.</h2>
                <p class="pd-cookie-modal__intro">Pick the cookies you're comfortable with. We don't track without your say-so.</p>
                <div class="pd-cookie-modal__group">
                  <div class="pd-cookie-modal__group-text">
                    <p class="pd-cookie-modal__group-title">Essential</p>
                    <p class="pd-cookie-modal__group-desc">Keep the cart, checkout, and login working. Always on.</p>
                  </div>
                  <label class="pd-cookie-modal__group-toggle">
                    <input type="checkbox" checked disabled>
                    <span class="pd-toggle-track"></span>
                  </label>
                </div>
                <div class="pd-cookie-modal__group">
                  <div class="pd-cookie-modal__group-text">
                    <p class="pd-cookie-modal__group-title">Analytics</p>
                    <p class="pd-cookie-modal__group-desc">See which guides land. Helps us write better ones.</p>
                  </div>
                  <label class="pd-cookie-modal__group-toggle">
                    <input type="checkbox" data-pd-pref="analytics" checked>
                    <span class="pd-toggle-track"></span>
                  </label>
                </div>
                <div class="pd-cookie-modal__group">
                  <div class="pd-cookie-modal__group-text">
                    <p class="pd-cookie-modal__group-title">Marketing</p>
                    <p class="pd-cookie-modal__group-desc">Personalised follow-ups about new releases.</p>
                  </div>
                  <label class="pd-cookie-modal__group-toggle">
                    <input type="checkbox" data-pd-pref="marketing" checked>
                    <span class="pd-toggle-track"></span>
                  </label>
                </div>
                <div class="pd-cookie-modal__actions">
                  <button type="button" class="pd-cookie-modal__btn pd-cookie-modal__btn--save" data-pd-modal="save">Save preferences</button>
                  <button type="button" class="pd-cookie-modal__btn pd-cookie-modal__btn--cancel" data-pd-modal="cancel">Cancel</button>
                </div>
              </div>
            `;
            document.body.appendChild(modal);

            modal.addEventListener('click', (e) => {
              if (e.target === modal) closeModal();
              const action = e.target.closest('[data-pd-modal]')?.dataset.pdModal;
              if (action === 'cancel') closeModal();
              if (action === 'save') savePrefs();
            });
          }
          modal.setAttribute('data-pd-shown', '1');
        }
        function closeModal() {
          const m = document.querySelector('.pd-cookie-modal');
          if (m) m.removeAttribute('data-pd-shown');
        }
        function savePrefs() {
          const modal = document.querySelector('.pd-cookie-modal');
          const analytics = modal.querySelector('[data-pd-pref="analytics"]').checked;
          const marketing = modal.querySelector('[data-pd-pref="marketing"]').checked;
          try {
            localStorage.setItem('pd-cookie-consent', JSON.stringify({
              choice: (analytics || marketing) ? 'custom' : 'decline',
              analytics, marketing,
              ts: new Date().toISOString()
            }));
          } catch (_) {}
          // Apply via Customer Privacy API
          if (window.Shopify && window.Shopify.loadFeatures) {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
              try {
                window.Shopify.customerPrivacy.setTrackingConsent({
                  analytics, marketing,
                  preferences: analytics,
                  sale_of_data: marketing
                }, () => {});
              } catch (_) {}
            });
          }
          closeModal();
          const banner = document.querySelector('.pd-cookie-banner');
          if (banner) {
            banner.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
            banner.style.opacity = '0';
            banner.style.transform = 'translateY(20px)';
            setTimeout(() => banner.remove(), 320);
          }
          window.pdToast && window.pdToast('Preferences saved', 'success');
        }
      })();

      // Format badge auto-injection on product cards (based on URL)
      // In de cover-hoek (card-gallery, absolute) — vóór de titel-link
      // geplaatst werd hij door de kaart-grid tot volle breedte gerekt en
      // hing hij als losse grijze balk boven de kaart (fixlist #10).
      // 02-09 audit (desktop P3-7 / mobile P3-8): de JS-formaatbadge "PDF" op de cover is
      // verwijderd. Hij liep alleen bij de eerste render (latere rijen misten hem), stapelde
      // op mobiel over hartje en Sale-badge, en alles is PDF. Het formaat staat nu in de
      // meta-regel van de kaart (snippets/product-card.liquid: "PDF · N min · 16 languages").

      // Detect keyboard usage to enable refined focus indicators
      (function pdKeyboardDetect() {
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Tab') document.body.classList.add('using-keyboard');
        });
        document.addEventListener('mousedown', () => {
          document.body.classList.remove('using-keyboard');
        });
      })();

      // Image lightbox — click product image to zoom
      (function pdImageLightbox() {
        if (!document.body.classList.contains('template-product')) return;
        const productImages = document.querySelectorAll('.product-media img, [class*="product-media-gallery"] img');
        if (!productImages.length) return;
        productImages.forEach(img => {
          img.style.cursor = 'zoom-in';
          img.addEventListener('click', (e) => {
            e.preventDefault();
            const lightbox = document.createElement('div');
            lightbox.style.cssText = `
              position: fixed; inset: 0; z-index: 10000;
              background: rgba(14, 27, 44, 0.92); backdrop-filter: blur(8px);
              display: flex; align-items: center; justify-content: center;
              padding: 24px; cursor: zoom-out;
              animation: pd-fade-in 0.3s var(--pd-ease-soft) both;
            `;
            const fullImg = document.createElement('img');
            fullImg.src = img.src;
            fullImg.alt = img.alt || '';
            fullImg.style.cssText = `
              max-width: 100%; max-height: 100%; object-fit: contain;
              border-radius: 4px; box-shadow: 0 24px 80px rgba(0,0,0,0.5);
              animation: pd-modal-in 0.4s var(--pd-ease-bounce) both;
            `;
            const closeBtn = document.createElement('button');
            closeBtn.innerHTML = '×';
            closeBtn.setAttribute('aria-label', 'Close');
            closeBtn.style.cssText = `
              position: absolute; top: 24px; right: 24px;
              width: 44px; height: 44px; border-radius: 50%;
              background: rgba(247, 243, 236, 0.15); color: #F7F3EC;
              border: 0; font-size: 1.5rem; cursor: pointer;
              display: flex; align-items: center; justify-content: center;
              transition: background 0.2s ease;
            `;
            closeBtn.addEventListener('mouseenter', () => {
              closeBtn.style.background = 'rgba(247, 243, 236, 0.3)';
            });
            closeBtn.addEventListener('mouseleave', () => {
              closeBtn.style.background = 'rgba(247, 243, 236, 0.15)';
            });
            lightbox.appendChild(fullImg);
            lightbox.appendChild(closeBtn);
            document.body.appendChild(lightbox);
            document.body.style.overflow = 'hidden';
            // L4-fix (audit 28-08): keydown-listener ook opruimen bij klik-sluiten
            const escHandler = (ev) => {
              if (ev.key === 'Escape') close();
            };
            const close = () => {
              lightbox.remove();
              document.body.style.overflow = '';
              document.removeEventListener('keydown', escHandler);
            };
            lightbox.addEventListener('click', (ev) => {
              if (ev.target !== fullImg) close();
            });
            document.addEventListener('keydown', escHandler);
          });
        });
      })();

      // Auto-inject editorial breadcrumb on collection + product + article pages
      (function pdBreadcrumbs() {
        const isProduct = document.body.classList.contains('template-product');
        const isCollection = document.body.classList.contains('template-collection');
        const isArticle = document.body.classList.contains('template-article') ||
                          document.body.classList.contains('template-blog-post');
        if (!isProduct && !isCollection && !isArticle) return;
        if (document.querySelector('.pd-breadcrumb')) return;

        const path = location.pathname.split('/').filter(Boolean);
        const titleEl = document.querySelector('h1, .product-title, [class*="page-title"]');
        if (!titleEl) return;

        /* 08-09 (doc 49 A4): labels en Home-link per taal uit pdCfg.i18n (layout/theme.liquid) */
        const L = (window.pdCfg && pdCfg.i18n) || {};
        let trail = ['<a href="' + ((window.pdCfg && pdCfg.root) || '/') + '">' + (L.home || 'Home') + '</a>'];
        if (isCollection && path[1]) {
          trail.push('<span>·</span>');
          trail.push('<span>' + (L.catalogue || 'Catalogue') + '</span>');
        } else if (isProduct) {
          trail.push('<span>·</span>');
          trail.push('<a href="' + pdCfg.collectionsUrl + '/pdf-guides">' + (L.catalogue || 'Catalogue') + '</a>');
        } else if (isArticle) {
          trail.push('<span>·</span>');
          trail.push('<a href="' + pdCfg.root + 'blogs/news">' + (L.journal || 'Journal') + '</a>');
        }
        // Don't repeat the page title — let it stand alone

        const nav = document.createElement('nav');
        nav.className = 'pd-breadcrumb breadcrumb';
        nav.setAttribute('aria-label', 'Breadcrumb');
        nav.innerHTML = trail.join(' ');
        // 13-09 (sweep D, punt 5): hier stond opacity 0.6. Een computed style meldde dan 12,98:1,
        // maar de ECHTE schermpixels gaven rgb(124,122,119) op crème = 3,87:1, onder de 4,5 die
        // WCAG voor gewone tekst vraagt. Opacity is daarom vervangen door een vaste kleur die wel
        // te meten is: #5A6472 haalt 5,42:1 en leest nog steeds als gedempt.
        nav.style.cssText = 'max-width: 1200px; margin: 0 auto; padding: 16px 24px 0; font-family: var(--font-heading--family); font-size: 0.6875rem; font-weight: 600; letter-spacing: 0.22em; text-transform: uppercase; color: #5A6472;';

        // Insert at top of main content
        const main = document.getElementById('MainContent');
        if (main && main.firstChild) {
          main.insertBefore(nav, main.firstChild);
        }
      })();

      // ============================================================
      // ROUND 12 FEATURES — wishlist, exit-intent, counters, upsell
      // ============================================================

      // Wishlist heart icon on every product card + header count
      (function pdWishlist() {
        const KEY = 'pd-wishlist';
        function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } }
        function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {} }

        // ==== A1 accountsync (28-08, bouwplan 22) ====================
        // Ingelogd: customer-id als UI-hint (autorisatie gebeurt ALTIJD
        // serverzijde via het door Shopify ondertekende logged_in_customer_id
        // op de app proxy). Serverlijst komt gratis mee via Liquid.
        const CUST = pdCfg.cust;
        const SERVER_LIST = pdCfg.serverList;
        const API = '/apps/primerdeck/wishlist'; // NOOIT met taal-prefix (proxy-beperking)
        let syncDirty = false;
        let syncInFlight = false;
        let syncTimer = null;
        // 02-09 audit P2-4: exponentiële backoff (0.8s -> max 60s, jitter), stop na 8 mislukkingen
        // tot de volgende gebruikersactie, zodat een haperende backend niet wordt overspoeld.
        let syncFailures = 0;
        let syncRetryDelay = 4000;

        // Locale-prefix strippen zodat /nl/products/x en /products/x 1 item zijn
        function normUrl(u) {
          try {
            const x = new URL(u, location.origin);
            const path = x.pathname.replace(/^\/[a-z]{2}(?:-[A-Za-z]{2})?(?=\/products\/)/, '');
            const v = x.searchParams.get('variant');
            return path + (v ? '?variant=' + v : '');
          } catch (_) { return u; }
        }
        function payload() {
          return { items: read().slice(0, 250).map(i => ({
            url: normUrl(i.url), name: String(i.name || '').slice(0, 200), ts: Number(i.ts) || Date.now()
          })) };
        }
        async function pushSync() {
          if (!CUST || syncInFlight) return;
          syncInFlight = true;
          syncDirty = false;
          try {
            const r = await fetch(API, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload())
            });
            if (!r.ok) {
              syncDirty = true;
              const ra = parseInt(r.headers.get('Retry-After') || '0', 10);
              if (ra > 0) syncRetryDelay = Math.max(syncRetryDelay, ra * 1000);
            } else {
              syncFailures = 0;
              syncRetryDelay = 4000;
            }
          } catch (_) { syncDirty = true; }
          syncInFlight = false;
          if (syncDirty) {
            syncFailures += 1;
            if (syncFailures > 8) return; // opgeven tot de volgende hart-klik
            clearTimeout(syncTimer);
            syncTimer = setTimeout(pushSync, syncRetryDelay + Math.floor(Math.random() * 500));
            syncRetryDelay = Math.min(60000, syncRetryDelay * 2);
          }
        }
        // Debounce: snel togglen collapse't tot 1 write met de eindstand
        function scheduleSync() {
          if (!CUST) return;
          syncDirty = true;
          syncFailures = 0;
          syncRetryDelay = 4000;
          clearTimeout(syncTimer);
          syncTimer = setTimeout(pushSync, 800);
        }
        // Horizon is MPA: zonder flush verdwijnt een write bij doorklikken
        addEventListener('pagehide', () => {
          if (!CUST || !syncDirty) return;
          try {
            navigator.sendBeacon(API, new Blob([JSON.stringify(payload())], { type: 'application/json' }));
            syncDirty = false;
          } catch (_) {}
        });
        // Union-merge, 1x per sessie (guard voorkomt dat een verwijdering op
        // een ander apparaat elke pageload terug-merged uit de lokale cache)
        (function mergeOnLogin() {
          if (!CUST) return;
          const server = Array.isArray(SERVER_LIST) ? SERVER_LIST : [];
          let merged = null;
          try { merged = sessionStorage.getItem('pd-wishlist-merged'); } catch (_) {}
          if (String(merged) === String(CUST)) { write(server); return; }
          const map = new Map();
          server.forEach(i => { if (i && i.url) map.set(normUrl(i.url), i); });
          read().forEach(i => {
            if (!i || !i.url) return;
            const k = normUrl(i.url);
            if (!map.has(k)) map.set(k, i);
            else if ((i.ts || 0) < (map.get(k).ts || 0)) map.get(k).ts = i.ts; // oudste ts wint
          });
          const union = [...map.values()];
          write(union);
          try { sessionStorage.setItem('pd-wishlist-merged', String(CUST)); } catch (_) {}
          if (union.length !== server.length) scheduleSync();
        })();
        // ==== einde accountsync ======================================

        function svg() {
          return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-4.35-9.5-8.6C.91 9.27 2.7 5.5 6 5.5c2 0 3.5 1 6 3.5 2.5-2.5 4-3.5 6-3.5 3.3 0 5.09 3.77 3.5 6.9C19 16.65 12 21 12 21z" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        }

        function inject() {
          const list = read();
          document.querySelectorAll('.product-card, .pd-card, .product-card-wrapper').forEach(card => {
            if (card.querySelector('.pd-wishlist-btn')) return;
            // Sommige kaarten ZIJN zelf de link (homepage-carrousel en
            // colcards gebruiken <a class="pd-card">), andere hebben de link
            // binnenin (collectiekaarten). Beide gevallen afvangen, anders
            // verschijnt het hartje op de helft van de kaarten niet.
            const link = card.matches('a[href*="/products/"]')
              ? card
              : card.querySelector('a[href*="/products/"]');
            if (!link) return;
            const url = link.getAttribute('href');
            if (!url) return;
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'pd-wishlist-btn';
            btn.setAttribute('aria-label', 'Save to wishlist');
            btn.dataset.pdUrl = url;
            btn.innerHTML = svg();
            if (list.some(i => i.url === url)) btn.setAttribute('data-pd-saved', '1');
            // 03-09 scroll-fix: geen getComputedStyle per kaart meer (forceerde per kaart
            // een layout na de vorige appendChild); position:relative staat nu in de CSS.
            card.appendChild(btn);
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const cur = read();
              const idx = cur.findIndex(i => i.url === url);
              if (idx > -1) {
                cur.splice(idx, 1);
                btn.removeAttribute('data-pd-saved');
                if (window.pdToast) window.pdToast('Removed from wishlist');
              } else {
                const titleEl = card.querySelector('.product-card__title, .card__heading, .pd-card-title') || link;
                cur.push({
                  url,
                  name: titleEl ? titleEl.textContent.trim() : '',
                  ts: Date.now()
                });
                btn.setAttribute('data-pd-saved', '1');
                if (window.pdToast) window.pdToast('Saved to wishlist');
              }
              write(cur);
              updateHeaderCount();
              scheduleSync();
            });
          });
        }
        function updateHeaderCount() {
          const count = read().length;
          document.querySelectorAll('.pd-wishlist-header-icon').forEach(el => {
            el.setAttribute('data-pd-count', count);
          });
        }
        // 02-09 audit P2-18: hartje op de productpagina zelf (naast de koopknoppen).
        function injectPdp() {
          if (!document.body.classList.contains('template-product')) return;
          if (document.querySelector('.pd-wishlist-btn--pdp')) return;
          if (location.pathname.indexOf('library-access') > -1) return;
          const anchor = document.querySelector('.product-information .product-form-buttons, .product-information product-form-component, .product-information [class*="buy-buttons"]');
          const h1 = document.querySelector('.product-information h1');
          if (!anchor || !h1) return;
          const url = normUrl(location.pathname);
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pd-wishlist-btn pd-wishlist-btn--pdp';
          btn.dataset.pdUrl = url;
          const label = document.createElement('span');
          const setLabel = (saved) => {
            label.textContent = saved ? 'Saved' : 'Save for later';
            btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
            if (saved) btn.setAttribute('data-pd-saved', '1'); else btn.removeAttribute('data-pd-saved');
          };
          btn.innerHTML = svg();
          btn.appendChild(label);
          setLabel(read().some(i => normUrl(i.url) === url));
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const cur = read();
            const idx = cur.findIndex(i => normUrl(i.url) === url);
            if (idx > -1) { cur.splice(idx, 1); setLabel(false); if (window.pdToast) window.pdToast('Removed from wishlist'); }
            else { cur.push({ url, name: h1.textContent.trim(), ts: Date.now() }); setLabel(true); if (window.pdToast) window.pdToast('Saved to wishlist'); }
            write(cur);
            updateHeaderCount();
            scheduleSync();
          });
          anchor.insertAdjacentElement('afterend', btn);
        }
        // Wishlist-pagina meldt verwijderingen via dit event (header-teller bleef anders staan)
        window.addEventListener('pd:wishlist-changed', updateHeaderCount);
        // Run on load + after AJAX renders new cards
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => { inject(); injectPdp(); });
        } else {
          inject(); injectPdp();
        }
        document.addEventListener('shopify:section:load', () => { inject(); injectPdp(); }); // alleen theme-editor
        // Re-inject wanneer Horizon de DOM vervangt (onderzoek 28-08):
        // 'facets:updated'/'collection:updated' bestaan NIET in Horizon (worden
        // nergens gedispatcht). Filteren rendert via morph.js en veegt de
        // hartjes weg zonder event; paginatie append't kaarten zonder event.
        // Een MutationObserver op MainContent is de enige betrouwbare haak.
        // inject() is idempotent (guard op bestaande .pd-wishlist-btn), dus de
        // zelf-veroorzaakte mutatie eindigt in een goedkope no-op.
        function pdObserve() {
          const root = document.getElementById('MainContent') || document.querySelector('main') || document.body;
          let t = null;
          new MutationObserver((records) => {
            // 03-09 scroll-fix: alleen reageren op echte nieuwe kaarten, niet op elke mutatie
            if (!records.some(r => r.addedNodes && r.addedNodes.length)) return;
            clearTimeout(t);
            t = setTimeout(() => { inject(); injectPdp(); }, 250);
          }).observe(root, { childList: true, subtree: true });
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', pdObserve);
        } else {
          pdObserve();
        }
        updateHeaderCount();
      })();

      // Nieuwsbrief-popup (desktop). Regels van de operator (aug 2026):
      // verschijnt PAS na 60 seconden op de site, en zodra hij is weggeklikt
      // komt hij nooit meer terug (permanent onthouden, ook in latere bezoeken).
      (function pdExitIntent() {
        if (window.matchMedia('(hover: none), (pointer: coarse), (max-width: 768px)').matches) return;
        try {
          if (localStorage.getItem('pd-exit-dismissed')) return;
          if (sessionStorage.getItem('pd-exit-shown')) return;
        } catch (_) {}
        let triggered = false;
        function build() {
          if (triggered) return;
          triggered = true;
          try { sessionStorage.setItem('pd-exit-shown', '1'); } catch (_) {}

          /* 08-09 (doc 49 A4/D7): teksten per taal uit pdCfg.i18n (layout/theme.liquid) */
          const L = (window.pdCfg && pdCfg.i18n) || {};
          const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
          const modal = document.createElement('div');
          modal.className = 'pd-exit-modal';
          modal.setAttribute('role', 'dialog');
          modal.setAttribute('aria-modal', 'true');
          modal.setAttribute('aria-labelledby', 'pd-exit-title');
          modal.innerHTML = `
            <div class="pd-exit-modal__panel">
              <button type="button" class="pd-exit-modal__close" aria-label="${esc(L.exit_close || 'Close')}">×</button>
              <span class="pd-exit-modal__badge">${esc(L.exit_badge || 'Free guide · every month')}</span>
              <h2 class="pd-exit-modal__title" id="pd-exit-title">${L.exit_title || 'Get a <em>free guide</em><br>every month.'}</h2>
              <p class="pd-exit-modal__sub">${esc(L.exit_sub || 'Join the list and we send you one complete PrimerDeck guide every month. No cost, no spam.')}</p>
              <div data-pd-form-slot></div>
              <p class="pd-exit-modal__note">${esc(L.exit_note || '1 FREE GUIDE · ONCE A MONTH')}</p>
            </div>
          `;
          // Echt Shopify customer-form (met form_type/utf8/authenticity door
          // Liquid gerenderd) staat als <template id="pd-exit-form-tpl"> in de
          // body; hier inklonen zodat de POST door Shopify geaccepteerd wordt.
          const tpl = document.getElementById('pd-exit-form-tpl');
          const srcForm = tpl && tpl.content ? tpl.content.querySelector('form') : null;
          if (!srcForm) return;
          const formClone = srcForm.cloneNode(true);
          modal.querySelector('[data-pd-form-slot]').replaceWith(formClone);
          formClone.addEventListener('submit', () => {
            try {
              sessionStorage.setItem('pd-exit-submitted', '1');
              localStorage.setItem('pd-exit-dismissed', '1');
            } catch (_) {}
          });
          document.body.appendChild(modal);
          requestAnimationFrame(() => modal.setAttribute('data-pd-shown', '1'));

          const close = () => {
            // permanent onthouden: hierna nooit meer tonen
            try { localStorage.setItem('pd-exit-dismissed', '1'); } catch (_) {}
            modal.style.transition = 'opacity 0.3s ease';
            modal.style.opacity = '0';
            setTimeout(() => modal.remove(), 320);
          };
          // Sluiten via het kruisje (operator, aug 2026: geen klik-buiten). 02-09 audit
          // P2-10: Escape sluit wel (WCAG 2.1.2, geen toetsenbordval) en de focus gaat
          // bij openen naar de sluitknop zodat toetsenbordgebruikers niet vastzitten.
          const closeBtn = modal.querySelector('.pd-exit-modal__close');
          closeBtn.addEventListener('click', close);
          // 08-09 (doc 40 D7): focus-trap zolang de modal open is; Escape sluit (WCAG 2.1.2)
          modal.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') { close(); return; }
            if (e.key !== 'Tab') return;
            const f = [...modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')].filter((el) => !el.disabled && el.offsetParent !== null);
            if (!f.length) return;
            const first = f[0], last = f[f.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
          });
          setTimeout(() => { try { closeBtn.focus(); } catch (_) {} }, 350);
        }
        // Geen exit-intent-trigger meer: de popup mag nooit binnen de eerste
        // minuut verschijnen. Enige trigger is de timer van 60 seconden.
        // 08-09 (doc 40 D7): nooit twee overlays tegelijk. Staat de cookiebanner (eigen of
        // die van Shopify) nog open, dan wacht de popup op de keuze en komt hij daarna.
        // Shopify's eigen banner blijft na een keuze in de DOM staan met display:none (gemeten
        // 08-09), dus alleen ZICHTBAARHEID telt; anders zou de popup nooit meer verschijnen.
        const onScreen = (el) => !!el && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        const cookieOpen = () => onScreen(document.querySelector('.pd-cookie-banner')) || onScreen(document.querySelector('#shopify-pc__banner'));
        const buildWhenClear = () => {
          if (!cookieOpen()) return build();
          const onChoice = () => { document.removeEventListener('pd:cookie-consent', onChoice); setTimeout(build, 1500); };
          document.addEventListener('pd:cookie-consent', onChoice);
          // Shopify's eigen banner stuurt geen event: kort blijven kijken tot hij weg is
          const poll = setInterval(() => { if (!cookieOpen()) { clearInterval(poll); document.removeEventListener('pd:cookie-consent', onChoice); setTimeout(build, 1500); } }, 2000);
        };
        setTimeout(buildWhenClear, 60000);
      })();

      // Product facts badge under the H1 — static, truthful (the previous
      // "[n] people reading this" fabricated a number; honesty rule forbids it)
      (function pdProductFacts() {
        if (!document.body.classList.contains('template-product')) return;
        const target = document.querySelector('h1.product-title, [class*="product-information"] h1, .product__title h1');
        if (!target) return;
        if (document.querySelector('.pd-viewing-now')) return;
        const indicator = document.createElement('div');
        indicator.className = 'pd-viewing-now';
        indicator.textContent = pdCfg.factsLabel;
        // Insert after H1
        target.parentNode.insertBefore(indicator, target.nextSibling);
      })();

      // Animated number counters — IntersectionObserver-based
      (function pdAnimatedCounters() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            if (el.dataset.pdCounted === '1') return;
            el.dataset.pdCounted = '1';
            const target = parseInt(el.dataset.pdTarget || el.textContent.replace(/[^\d]/g, ''), 10);
            if (!target) return;
            const suffix = el.textContent.replace(/[\d,.]/g, '').trim();
            const duration = 1200;
            const start = performance.now();
            function tick(now) {
              const t = Math.min((now - start) / duration, 1);
              const eased = 1 - Math.pow(1 - t, 3);
              const v = Math.floor(target * eased);
              el.textContent = v.toLocaleString('en-US') + suffix;
              if (t < 1) {
                el.classList.add('pd-counter--ticking');
                requestAnimationFrame(tick);
              } else {
                el.classList.remove('pd-counter--ticking');
              }
            }
            requestAnimationFrame(tick);
            observer.unobserve(el);
          });
        }, { threshold: 0.5 });
        document.querySelectorAll('.pd-counter').forEach(el => observer.observe(el));
      })();

      // Cart upsell strip — show 1 random featured product when cart has items
      (function pdCartUpsell() {
        const RECOMMENDATION_HANDLES = ['signals-guide', 'manipulation-primer', 'cat-health-field-manual'];
        async function inject() {
          // M1-fix (audit 28-08): de oude selector (.cart-drawer .drawer__inner)
          // bestond niet in Horizon -> upsell was een dode feature. Echte
          // drawer = <cart-drawer-component> .cart-drawer__inner.
          const drawer = document.querySelector('cart-drawer-component .cart-drawer__inner');
          if (!drawer) return;
          if (drawer.querySelector('.pd-cart-upsell')) return;
          try {
            const r = await fetch('/cart.js');
            const cart = await r.json();
            if (cart.item_count === 0) return;

            const inCartHandles = cart.items.map(i => i.handle);
            const candidates = RECOMMENDATION_HANDLES.filter(h => !inCartHandles.includes(h));
            if (candidates.length === 0) return;
            const pick = candidates[Math.floor(Math.random() * candidates.length)];

            const productR = await fetch(`/products/${pick}.js`);
            if (!productR.ok) return;
            const product = await productR.json();
            const upsell = document.createElement('div');
            upsell.className = 'pd-cart-upsell';
            // L5-fix: geen titel-interpolatie in innerHTML (quotes in een titel
            // braken het attribuut); tekst via textContent, knop NAAST de link
            // (button-in-a was invalide HTML).
            upsell.innerHTML = `
              <p class="pd-cart-upsell__kicker">YOU MIGHT ALSO LIKE</p>
              <div class="pd-cart-upsell__item">
                <a class="pd-cart-upsell__link" href="${product.url}">
                  <div class="pd-cart-upsell__image"></div>
                  <div class="pd-cart-upsell__details">
                    <p class="pd-cart-upsell__name"></p>
                    <p class="pd-cart-upsell__price">€${(product.price / 100).toFixed(2).replace('.', ',')}</p>
                  </div>
                </a>
                <button type="button" class="pd-cart-upsell__add">Add</button>
              </div>
            `;
            upsell.querySelector('.pd-cart-upsell__name').textContent = product.title;
            if (product.featured_image) {
              const img = document.createElement('img');
              img.src = product.featured_image;
              img.alt = product.title;
              img.loading = 'lazy';
              upsell.querySelector('.pd-cart-upsell__image').appendChild(img);
            }
            const totals = drawer.querySelector('.totals, .cart-summary, [class*="cart-footer"]');
            if (totals && totals.parentNode) {
              totals.parentNode.insertBefore(upsell, totals);
            } else {
              drawer.appendChild(upsell);
            }
            upsell.querySelector('.pd-cart-upsell__add').addEventListener('click', async (e) => {
              e.preventDefault();
              e.stopPropagation();
              try {
                const addR = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: product.variants[0].id, quantity: 1 })
                });
                if (addR.ok) {
                  if (window.pdToast) window.pdToast('Added to cart');
                  document.dispatchEvent(new CustomEvent('pd:track', { detail: { name: 'add_to_cart', payload: { variant_id: product.variants[0].id } } }));
                  upsell.remove();
                  // Horizon-drawer ververst op het cart:update-event
                  // (Shopify.theme.refreshCart bestond niet).
                  const updated = await (await fetch('/cart.js')).json();
                  const evt = new Event('cart:update', { bubbles: true });
                  evt.detail = { resource: updated, sourceId: 'pd-cart-upsell', data: { source: 'product-form-component', itemCount: updated.item_count } };
                  document.dispatchEvent(evt);
                } else {
                  if (window.pdToast) window.pdToast('Could not add', 'error');
                }
              } catch (err) {
                if (window.pdToast) window.pdToast('Could not add', 'error');
              }
            });
          } catch (_) {}
        }
        // Inject when cart drawer opens
        document.addEventListener('click', e => {
          if (e.target.closest('[data-cart-drawer-trigger], .header-actions__cart, [aria-controls*="cart"]')) {
            setTimeout(inject, 400);
          }
        });
        // Or on add-to-cart event
        document.addEventListener('pd:track', e => {
          if (e.detail && e.detail.name === 'add_to_cart') setTimeout(inject, 800);
        });
        // Horizon's eigen cart-event (native add-to-cart flow opent de drawer
        // zonder pd:track; zonder deze listener verscheen de upsell nooit)
        document.addEventListener('cart:update', () => setTimeout(inject, 500));
      })();

      // Reduced-motion toggle — adds button to footer
      (function pdMotionToggle() {
        // Restore preference
        try {
          const pref = localStorage.getItem('pd-motion');
          if (pref === 'off') document.body.setAttribute('data-pd-motion', 'off');
        } catch (_) {}
        // Inject toggle into footer (after page load)
        function inject() {
          const footer = document.querySelector('[class*="pd-footer-"] .pd-bottom, footer .pd-bottom');
          if (!footer) return;
          if (footer.querySelector('.pd-motion-toggle')) return;
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pd-motion-toggle';
          btn.setAttribute('aria-label', 'Toggle motion');
          const isOff = document.body.getAttribute('data-pd-motion') === 'off';
          btn.innerHTML = `<span class="pd-motion-toggle__indicator"></span> Motion · ${isOff ? 'Off' : 'On'}`;
          footer.appendChild(btn);
          btn.addEventListener('click', () => {
            const curOff = document.body.getAttribute('data-pd-motion') === 'off';
            if (curOff) {
              document.body.removeAttribute('data-pd-motion');
              try { localStorage.setItem('pd-motion', 'on'); } catch (_) {}
              btn.innerHTML = `<span class="pd-motion-toggle__indicator"></span> Motion · On`;
            } else {
              document.body.setAttribute('data-pd-motion', 'off');
              try { localStorage.setItem('pd-motion', 'off'); } catch (_) {}
              btn.innerHTML = `<span class="pd-motion-toggle__indicator"></span> Motion · Off`;
            }
          });
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', inject);
        } else {
          inject();
        }
      })();

      // Floating "back to home" pill on inner pages (desktop)
      (function pdBackPill() {
        if (document.body.classList.contains('template-index') ||
            document.body.classList.contains('template-cart') ||
            document.body.classList.contains('template-checkout')) return;
        if (window.matchMedia('(max-width: 768px)').matches) return;
        if (document.querySelector('.pd-back-pill')) return;
        const pill = document.createElement('a');
        pill.className = 'pd-back-pill';
        pill.href = '/';
        pill.textContent = 'Home';
        document.body.appendChild(pill);
      })();

      // Sticky reading shelf on cart page mobile (cart total + checkout)
      (function pdReadingShelf() {
        if (!document.body.classList.contains('template-cart')) return;
        if (window.matchMedia('(min-width: 769px)').matches) return;
        async function inject() {
          if (document.querySelector('.pd-reading-shelf')) return;
          // H1-fix (audit 28-08): geen directe /checkout-link meer - die
          // omzeilde de verplichte voorwaarden-checkbox (pd-cart-terms.js
          // vergrendelt alleen de echte knop in .cart__ctas). De shelf-knop
          // klikt nu de echte checkout-knop door, dus de lock geldt ook hier.
          // try/catch = M4-fix (unhandled rejection bij netwerkfout).
          try {
            const r = await fetch('/cart.js');
            const cart = await r.json();
            if (cart.item_count === 0) return;
            const total = (cart.total_price / 100).toFixed(2);
            const currency = cart.currency || 'EUR';
            const symbol = currency === 'EUR' ? '€' : (currency === 'USD' ? '$' : currency + ' ');
            const shelf = document.createElement('div');
            shelf.className = 'pd-reading-shelf';
            shelf.innerHTML = `
              <span class="pd-reading-shelf__total">${symbol}${total}</span>
              <button type="button" class="pd-reading-shelf__btn">Checkout</button>
            `;
            shelf.querySelector('.pd-reading-shelf__btn').addEventListener('click', () => {
              const real = document.querySelector('.cart__ctas .cart__checkout-button, .cart__ctas button[name="checkout"]');
              if (real) {
                real.scrollIntoView({ block: 'center' });
                real.click();
              } else {
                window.location.href = '/checkout';
              }
            });
            document.body.appendChild(shelf);
          } catch (e) { /* shelf is optioneel; stil falen */ }
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', inject);
        } else {
          inject();
        }
      })();

      // Auto-inject section nav (TOC) on long article/page content
      (function pdSectionNav() {
        if (!document.body.classList.contains('template-article') &&
            !document.body.classList.contains('template-page') &&
            !document.body.classList.contains('template-blog-post')) return;
        const content = document.querySelector('.rte, .article__content');
        if (!content) return;
        const headings = content.querySelectorAll('h2');
        if (headings.length < 3) return; // only show on long articles

        const nav = document.createElement('nav');
        nav.className = 'pd-section-nav';
        nav.setAttribute('aria-label', 'Sections');
        nav.innerHTML = '<p class="pd-section-nav__title">In this guide</p><ol></ol>';
        const list = nav.querySelector('ol');
        headings.forEach((h, i) => {
          if (!h.id) h.id = 'section-' + (i + 1);
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent.trim();
          li.appendChild(a);
          list.appendChild(li);
        });
        content.parentNode.insertBefore(nav, content);
        // Active section tracking
        const links = nav.querySelectorAll('a');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              links.forEach(l => l.classList.remove('is-active'));
              const active = nav.querySelector(`a[href="#${entry.target.id}"]`);
              if (active) active.classList.add('is-active');
            }
          });
        }, { rootMargin: '-30% 0px -60% 0px' });
        headings.forEach(h => observer.observe(h));
      })();

      // First-visit detection (drives onboarding hints)
      (function pdFirstVisit() {
        try {
          if (!localStorage.getItem('pd-visited')) {
            document.body.setAttribute('data-pd-first-visit', '1');
            localStorage.setItem('pd-visited', '1');
            // Auto-clear after 10s so the hint isn't permanent
            setTimeout(() => document.body.removeAttribute('data-pd-first-visit'), 10000);
          }
        } catch (_) {}
      })();

      // Body-scroll lock when drawer/modal is open
      (function pdScrollLock() {
        const observer = new MutationObserver(() => {
          const open = !!document.querySelector('.cart-drawer[open], dialog[open], [aria-modal="true"]:not([hidden]), .pd-cookie-modal[data-pd-shown="1"], .pd-exit-modal[data-pd-shown="1"]');
          const has = document.body.classList.contains('pd-drawer-open');
          // Alleen schrijven bij een echte statuswissel: de observer kijkt ook
          // naar class-mutaties en de eigen classList-write triggerde anders
          // de callback opnieuw, een oneindige lus die de hele pagina bevroor.
          if (open && !has) document.body.classList.add('pd-drawer-open');
          else if (!open && has) document.body.classList.remove('pd-drawer-open');
        });
        // 03-09 scroll-fix: 'class' uit de attributeFilter. Elke class-wissel waar dan ook
        // (in-view bij reveals, hover-states) liet deze observer een document-brede
        // querySelector draaien tijdens het scrollen.
        observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'data-pd-shown', 'aria-modal', 'hidden'] });
      })();

      // Scroll-up detection — for header hide/show on scroll direction
      // 03-09 scroll-fix: pdScrollDirection (body.is-scrolled-up bij elke richtingwissel)
      // verwijderd; de header verbergt niet meer bij scrollen, dus de klasse had geen
      // functie meer en gaf alleen herstylings.

      // Animated SVG section divider — only between specific major-section pairs
      // (was inserting between every pair which felt too busy)
      (function pdAutoDividers() {
        // Only insert between these specific transitions
        const meaningfulPairs = [
          ['pd-pullquote', 'pd-colcards'],
          ['pd-compare', 'pd-story'],
          ['pd-story', 'pd-pullquote'],
          ['pd-stats', 'primerdeck-columns'],
          ['pd-faq', 'pd-cta']
        ];
        const sections = document.querySelectorAll('section[class*="pd-"]');
        sections.forEach((sec) => {
          const prev = sec.previousElementSibling;
          if (!prev || !prev.classList) return;
          if (prev.classList.contains('pd-section-divider')) return;

          const matches = meaningfulPairs.some(([a, b]) =>
            prev.className.includes(a) && sec.className.includes(b)
          );
          if (!matches) return;

          const divider = document.createElement('div');
          divider.className = 'pd-section-divider';
          divider.setAttribute('aria-hidden', 'true');
          divider.innerHTML = `
            <svg viewBox="0 0 120 18" fill="none">
              <line x1="0" y1="9" x2="48" y2="9" stroke="currentColor" stroke-width="1" opacity="0.3"/>
              <circle cx="60" cy="9" r="2.5" fill="currentColor" opacity="0.5"/>
              <line x1="72" y1="9" x2="120" y2="9" stroke="currentColor" stroke-width="1" opacity="0.3"/>
            </svg>
          `;
          divider.style.color = 'var(--color-primary, #C8A24A)';
          sec.parentNode.insertBefore(divider, sec);
        });
      })();

      // R20-A — Sample reader modal
      // Builds a lightbox modal from any [data-pd-sample-rail] container.
      // Triggered by [data-pd-open-sample-reader] buttons or by clicking
      // any spread image directly. Keyboard: arrows to nav, Esc to close.
      (function pdSampleReader() {
        const rails = document.querySelectorAll('[data-pd-sample-rail]');
        if (!rails.length) return;

        // Build single shared modal lazily on first open
        let modal, stage, counter, prevBtn, nextBtn, tocList, productTitleEl, buyLink;
        let pages = [];
        let pageIndex = 0;
        let titleText = (document.querySelector('.template-product h1') || {}).textContent || 'Sample';

        function ensureModal() {
          if (modal) return;
          modal = document.createElement('div');
          modal.className = 'pd-reader';
          modal.setAttribute('role', 'dialog');
          modal.setAttribute('aria-modal', 'true');
          modal.setAttribute('aria-label', 'Sample reader');
          modal.innerHTML = `
            <div class="pd-reader-frame">
              <aside class="pd-reader-aside">
                <div class="pd-reader-eyebrow">PRIMERDECK · SAMPLE</div>
                <div class="pd-reader-title" data-pd-reader-title></div>
                <div class="pd-reader-eyebrow" style="margin-top:32px;margin-bottom:10px;opacity:0.55;color:var(--color-primary-button-background,#C8A24A)">CONTENTS</div>
                <ul class="pd-reader-toc" data-pd-reader-toc></ul>
              </aside>
              <div class="pd-reader-stage">
                <button class="pd-reader-close" type="button" aria-label="Close sample">×</button>
                <figure class="pd-reader-page" data-pd-reader-page></figure>
                <div class="pd-reader-controls">
                  <button class="pd-reader-arrow" data-pd-reader-prev type="button" aria-label="Previous page">‹</button>
                  <span class="pd-reader-counter" data-pd-reader-counter>01 / 03</span>
                  <button class="pd-reader-arrow" data-pd-reader-next type="button" aria-label="Next page">›</button>
                </div>
                <a class="pd-reader-buy" href="#pd-buy-area" data-pd-reader-buy>Buy the full guide ↓</a>
              </div>
            </div>
          `;
          document.body.appendChild(modal);
          stage = modal.querySelector('[data-pd-reader-page]');
          counter = modal.querySelector('[data-pd-reader-counter]');
          prevBtn = modal.querySelector('[data-pd-reader-prev]');
          nextBtn = modal.querySelector('[data-pd-reader-next]');
          tocList = modal.querySelector('[data-pd-reader-toc]');
          productTitleEl = modal.querySelector('[data-pd-reader-title]');
          buyLink = modal.querySelector('[data-pd-reader-buy]');

          modal.addEventListener('click', (e) => {
            if (e.target === modal) close();
          });
          modal.querySelector('.pd-reader-close').addEventListener('click', close);
          prevBtn.addEventListener('click', () => render(pageIndex - 1));
          nextBtn.addEventListener('click', () => render(pageIndex + 1));
          buyLink.addEventListener('click', (e) => {
            e.preventDefault();
            close();
            const target = document.getElementById('pd-buy-area') ||
              document.querySelector('product-form, form[action*="/cart/add"]');
            if (target) {
              setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 350);
            }
          });
        }

        function render(idx) {
          if (idx < 0 || idx >= pages.length) return;
          pageIndex = idx;
          const page = pages[idx];
          const padN = (n) => String(n + 1).padStart(2, '0');
          counter.textContent = padN(idx) + ' / ' + String(pages.length).padStart(2, '0');
          prevBtn.disabled = idx === 0;
          nextBtn.disabled = idx === pages.length - 1;

          // 02-09 audit P3-3: DOM-API i.p.v. string-concatenatie (alt/titel kunnen quotes bevatten)
          if (page.image) {
            const img = document.createElement('img');
            img.src = page.image;
            img.alt = page.alt || ('Sample page ' + (idx + 1));
            stage.replaceChildren(img);
          } else {
            const fb = document.createElement('div');
            fb.className = 'pd-reader-page-fallback';
            const mk = (cls, text) => { const d = document.createElement('div'); d.className = cls; d.textContent = text; return d; };
            fb.appendChild(mk('pd-reader-page-fallback-eyebrow', page.eyebrow || ('PAGE ' + padN(idx))));
            fb.appendChild(mk('pd-reader-page-fallback-rule', ''));
            fb.appendChild(mk('pd-reader-page-fallback-title', page.title || 'A page from the guide.'));
            fb.appendChild(mk('pd-reader-page-fallback-body', page.body || 'Sample pages for this guide are being prepared.'));
            stage.replaceChildren(fb);
          }

          tocList.querySelectorAll('.pd-reader-toc-item').forEach((el, i) => {
            el.classList.toggle('is-active', i === idx);
          });
        }

        function buildToc() {
          tocList.innerHTML = pages.map((p, i) => `
            <li>
              <button class="pd-reader-toc-item${i === 0 ? ' is-active' : ''}" data-pd-toc-i="${i}">
                <span class="pd-reader-toc-num">${String(i + 1).padStart(2, '0')}</span>
                <span>${p.eyebrow || ('Page ' + (i + 1))}</span>
              </button>
            </li>
          `).join('');
          tocList.querySelectorAll('.pd-reader-toc-item').forEach(btn => {
            btn.addEventListener('click', () => render(parseInt(btn.dataset.pdTocI, 10)));
          });
        }

        function open(rail, startIndex) {
          ensureModal();
          pages = Array.from(rail.querySelectorAll('[data-pd-sample-open]')).map(spread => {
            const img = spread.querySelector('img');
            const eyebrow = spread.querySelector('.pd-spread-placeholder-eyebrow');
            const title = spread.querySelector('.pd-spread-placeholder-title');
            const pageMeta = spread.querySelector('.pd-spread-page');
            return {
              image: img ? img.currentSrc || img.src : null,
              alt: img ? img.alt : null,
              eyebrow: eyebrow ? eyebrow.textContent.trim() : (pageMeta ? pageMeta.textContent.trim() : null),
              title: title ? title.textContent.trim() : null,
              body: spread.dataset.pdBody || null
            };
          });
          if (!pages.length) return;
          if (productTitleEl) productTitleEl.textContent = titleText.trim();
          buildToc();
          render(typeof startIndex === 'number' ? startIndex : 0);
          document.body.classList.add('pd-reader-locked');
          modal.removeAttribute('hidden');
          requestAnimationFrame(() => modal.classList.add('is-open'));
          document.addEventListener('keydown', onKey);
        }

        function close() {
          if (!modal) return;
          modal.classList.remove('is-open');
          // hidden zetten: de reader blijft in de DOM en matcht anders
          // [aria-modal="true"]:not([hidden]) in pdScrollLock -> scroll bleef vast
          setTimeout(() => { if (modal && !modal.classList.contains('is-open')) modal.setAttribute('hidden', ''); }, 320);
          document.body.classList.remove('pd-reader-locked');
          document.removeEventListener('keydown', onKey);
        }

        function onKey(e) {
          if (e.key === 'Escape') close();
          else if (e.key === 'ArrowLeft') render(pageIndex - 1);
          else if (e.key === 'ArrowRight') render(pageIndex + 1);
        }

        // Wire openers
        rails.forEach(rail => {
          rail.querySelectorAll('[data-pd-sample-open]').forEach(spread => {
            spread.addEventListener('click', () => open(rail, parseInt(spread.dataset.pdSampleOpen, 10) || 0));
          });
        });
        document.querySelectorAll('[data-pd-open-sample-reader]').forEach(btn => {
          btn.addEventListener('click', () => {
            const targetId = btn.dataset.pdRailId;
            let rail;
            if (targetId) {
              const sec = document.getElementById(targetId);
              rail = sec ? sec.querySelector('[data-pd-sample-rail]') : null;
            }
            if (!rail) rail = document.querySelector('[data-pd-sample-rail]');
            if (rail) open(rail, 0);
          });
        });

        // Inject "Read sample" dual-CTA on PDP if a sample section exists
        if (document.body.classList.contains('template-product')) {
          const firstRail = document.querySelector('[data-pd-sample-rail]');
          const buyForm = document.querySelector('product-form, form[action*="/cart/add"]');
          if (firstRail && buyForm && !buyForm.querySelector('.pd-read-sample-cta')) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'pd-read-sample-cta';
            btn.textContent = 'Read a sample';
            btn.addEventListener('click', () => open(firstRail, 0));
            buyForm.appendChild(btn);
          }
        }
      })();

      // R20-B — Continue reading toast (long-form return on revisit)
      // Stores scroll position per-page in localStorage. Surfaces a toast
      // on next visit if the user scrolled past 25% last time and isn't
      // already at that position.
      (function pdContinueReading() {
        // 11-09 UITGEZET. Deze toast bewaarde `window.scrollY / max` en noemde dat "% READ".
        // Dat is scrolldiepte, geen leesvoortgang. Gemeten: een ankerlink volgen schreef 73%,
        // een muiswieltje op een korte pagina 100%, en de End-toets ook 100%. De gidsen zijn
        // PDF's die je downloadt, dus er is op de site helemaal geen leesvoortgang om te tonen.
        // Een getal dat iets over de klant beweert wat niet waar is hoort hier niet; om precies
        // dezelfde reden is de regel "downloads this week" hieronder al geschrapt.
        // Hij zat bovendien niet achter pd_reading_record_enabled en zijn teksten waren
        // hardgecodeerd Engels, terwijl dit bestand elders wel pdCfg.i18n gebruikt.
        // Weer aanzetten kan alleen met een echte bron van leesvoortgang, vertaalde teksten,
        // een opruiming van de opslagsleutel bij wegklikken, en achter de themaschakelaar.
        if (true) return;
        if (!('localStorage' in window)) return;
        const path = location.pathname;
        if (path === '/' || path === '/cart' || path.indexOf('/account') === 0) return;
        // Only on long pages (article, blog post, page, product)
        const eligible = ['template-article','template-blog-post','template-page','template-product']
          .some(cls => document.body.classList.contains(cls));
        if (!eligible) return;

        const KEY = 'pd:continue:' + path;
        let saved = null;
        try { saved = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}

        // Save scroll position throttled
        let saveTimer;
        function save() {
          clearTimeout(saveTimer);
          saveTimer = setTimeout(() => {
            const max = document.documentElement.scrollHeight - window.innerHeight;
            if (max <= 0) return;
            const pct = Math.round((window.scrollY / max) * 100);
            if (pct < 5) { localStorage.removeItem(KEY); return; }
            try {
              localStorage.setItem(KEY, JSON.stringify({ pct, ts: Date.now(), title: document.title }));
            } catch (e) {}
          }, 600);
        }
        document.addEventListener('scroll', save, { passive: true });
        window.addEventListener('beforeunload', save);

        // Show toast if user previously left mid-page and we're now at top
        // 02-09 audit P3-4: localStorage-vorm niet vertrouwen; pct hard naar 0..100 dwingen.
        // (Bewust zonder vergelijkingsoperatoren geschreven: de LiquidHTML-parser van
        // theme-check struikelde over de combinatie "< ... >" in deze regel.)
        if (saved) saved.pct = Math.max(0, Math.min(100, Number(saved.pct) || 0));
        const pdAgeMs = saved ? Date.now() - Number(saved.ts) : Infinity;
        const pdMaxAge = 1000 * 60 * 60 * 24 * 14;
        const pdRecentEnough = Math.max(pdAgeMs, pdMaxAge) === pdMaxAge;
        const pdFarEnough = saved ? Math.min(saved.pct, 25) === 25 : false;
        if (!saved || !pdFarEnough || !pdRecentEnough) return;
        if (window.scrollY > 300) return;

        const toast = document.createElement('div');
        toast.className = 'pd-continue-toast';
        toast.setAttribute('role', 'region');
        toast.setAttribute('aria-label', 'Continue reading');
        toast.innerHTML = `
          <div class="pd-continue-toast-text">
            <div class="pd-continue-toast-eyebrow">${saved.pct}% READ</div>
            <button type="button" class="pd-continue-toast-button">Continue where you left off</button>
          </div>
          <button type="button" class="pd-continue-toast-close" aria-label="Dismiss">×</button>
        `;
        document.body.appendChild(toast);

        toast.querySelector('.pd-continue-toast-button').addEventListener('click', () => {
          const max = document.documentElement.scrollHeight - window.innerHeight;
          window.scrollTo({ top: max * (saved.pct / 100), behavior: 'smooth' });
          dismiss();
        });
        toast.querySelector('.pd-continue-toast-close').addEventListener('click', dismiss);

        function dismiss() {
          toast.classList.remove('is-shown');
          setTimeout(() => toast.remove(), 600);
        }

        setTimeout(() => toast.classList.add('is-shown'), 1000);
        // Auto-hide after 12s
        setTimeout(dismiss, 13000);
      })();

      // R20-C — Footnote auto-numbering
      // Scans long-form prose for <sup data-fn> elements and auto-numbers
      // them, also inserting an inline marginalia note from corresponding
      // <aside class="pd-margin-note" data-fn="N"> at the same number.
      (function pdFootnotes() {
        const containers = document.querySelectorAll('.pd-prose, .template-page main .rte, .template-blog-post main .rte, .template-article main .rte');
        containers.forEach(container => {
          const refs = container.querySelectorAll('sup.pd-fn-ref, .pd-fn-ref');
          if (!refs.length) return;
          refs.forEach((ref, i) => {
            if (!ref.dataset.fn || ref.dataset.fn === 'auto') {
              ref.dataset.fn = String(i + 1);
              if (!ref.textContent.trim()) ref.textContent = String(i + 1);
            }
            ref.setAttribute('role', 'button');
            ref.setAttribute('tabindex', '0');
            ref.addEventListener('click', () => {
              const note = container.querySelector('.pd-margin-note[data-fn="' + ref.dataset.fn + '"]');
              if (note) note.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
          });
        });
      })();

      // R19-C is verwijderd: de "downloads this week"-regel fabriceerde een
      // getal uit een URL-hash — verboden door de eerlijkheidsregel.

      // R19-A — Generic data-pd-reveal observer
      // Adds .in-view to any element with [data-pd-reveal] when 12% visible.
      (function pdRevealObserver() {
        const els = document.querySelectorAll('[data-pd-reveal]:not(.in-view)');
        if (!els.length || !('IntersectionObserver' in window)) {
          els.forEach(e => e.classList.add('in-view'));
          return;
        }
        const io = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in-view');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.02, rootMargin: '0px 0px -4% 0px' }); // 03-09: eerder onthullen, niets blijft leeg tijdens scrollen
        els.forEach(el => io.observe(el));
      })();

      // R19-B — PDP scroll-spy anchor nav
      // Auto-injects a sticky horizontal nav on product templates that
      // contain at least 2 [data-pd-anchor] sections. Highlights the
      // active section as the user scrolls. Hidden until past the buy area.
      (function pdAnchorNav() {
        if (!document.body.classList.contains('template-product')) return;

        // Auto-tag known PrimerDeck section types so they show up in the spy
        const sectionTypeMap = [
          { pattern: /primerdeck-colophon-/, key: 'details', label: 'Details' },
          { pattern: /primerdeck-sample-/, key: 'sample', label: 'Sample' },
          { pattern: /primerdeck-columns-/, key: 'inside', label: "What's inside" },
          { pattern: /primerdeck-chapters-/, key: 'chapters', label: 'Chapters' },
          { pattern: /primerdeck-testimonials-/, key: 'reviews', label: 'Reviews' },
          { pattern: /primerdeck-pullquote-/, key: 'standard', label: 'The standard' },
          { pattern: /primerdeck-faq-/, key: 'faq', label: 'FAQ' }
        ];
        document.querySelectorAll('section[class*="primerdeck-"]').forEach(sec => {
          if (sec.dataset.pdAnchor) return;
          const match = sectionTypeMap.find(m => m.pattern.test(sec.className));
          if (match) {
            sec.dataset.pdAnchor = match.key;
            sec.dataset.pdAnchorLabel = match.label;
          }
        });

        const anchors = document.querySelectorAll('[data-pd-anchor]');
        if (anchors.length < 2) return;

        // Build nav structure
        const nav = document.createElement('nav');
        nav.className = 'pd-anchor-nav';
        nav.setAttribute('aria-label', 'Product sections');
        const track = document.createElement('div');
        track.className = 'pd-anchor-nav-track';
        nav.appendChild(track);

        // Always-first "Buy" link pointing back to the buy form
        const buyForm = document.querySelector('product-form, form[action*="/cart/add"]');
        if (buyForm) {
          if (!buyForm.id) buyForm.id = 'pd-buy-area';
          const buyLink = document.createElement('a');
          buyLink.href = '#' + buyForm.id;
          buyLink.className = 'pd-anchor-link';
          buyLink.dataset.pdAnchor = 'buy';
          buyLink.textContent = 'Buy';
          track.appendChild(buyLink);
        }

        anchors.forEach((sec, i) => {
          if (!sec.id) sec.id = 'pd-anchor-' + (sec.dataset.pdAnchor || ('s' + i));
          const link = document.createElement('a');
          link.href = '#' + sec.id;
          link.className = 'pd-anchor-link';
          link.dataset.pdAnchorTarget = sec.id;
          link.textContent = sec.dataset.pdAnchorLabel || (sec.dataset.pdAnchor || 'Section');
          track.appendChild(link);
        });

        // Insert nav directly after the product-information section
        const insertAfter = document.querySelector('.product-information, [class*="main-product"], [class*="product-info"]');
        if (insertAfter && insertAfter.parentNode) {
          insertAfter.parentNode.insertBefore(nav, insertAfter.nextSibling);
        } else if (buyForm && buyForm.parentNode) {
          buyForm.parentNode.parentNode.insertBefore(nav, buyForm.parentNode.nextSibling);
        } else {
          // Fallback: prepend to main
          const main = document.querySelector('main') || document.body;
          main.appendChild(nav);
        }

        // Smooth scroll with offset for the nav itself + sticky header
        track.addEventListener('click', (e) => {
          const a = e.target.closest('a.pd-anchor-link');
          if (!a) return;
          const targetId = a.getAttribute('href').slice(1);
          const target = document.getElementById(targetId);
          if (!target) return;
          e.preventDefault();
          const offset = 64 + nav.offsetHeight + 16;
          const y = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: y, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });

        // Show nav once we scroll past the buy area
        if ('IntersectionObserver' in window && buyForm) {
          const showIo = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) nav.classList.remove('is-visible');
              else nav.classList.add('is-visible');
            });
          }, { threshold: 0, rootMargin: '0px 0px -100% 0px' });
          showIo.observe(buyForm);
        } else {
          nav.classList.add('is-visible');
        }

        // Active-link spy
        if ('IntersectionObserver' in window) {
          const links = nav.querySelectorAll('.pd-anchor-link[data-pd-anchor-target]');
          const map = new Map();
          links.forEach(l => map.set(l.dataset.pdAnchorTarget, l));
          const spyIo = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              const link = map.get(entry.target.id);
              if (!link) return;
              if (entry.isIntersecting) {
                links.forEach(l => l.classList.remove('is-active'));
                link.classList.add('is-active');
              }
            });
          }, { threshold: 0, rootMargin: '-30% 0px -55% 0px' });
          anchors.forEach(s => spyIo.observe(s));
        }
      })();

      /* --------------------------------------------------------------
         Mobiel menu: focus terug naar de knop na Escape (13-09, sweep D punt 9).
         Escape sloot het menu wel, maar de focus viel op <body>. Wie met het toetsenbord of een
         schermlezer werkt stond dan bovenaan de pagina in plaats van bij de knop die hij net
         gebruikte, en moest opnieuw door de hele kop tabben. WCAG 2.4.3.
         -------------------------------------------------------------- */
      (function () {
        var houder = document.getElementById('Details-menu-drawer-container');
        if (!houder) return;
        var knop = houder.querySelector('summary');
        if (!knop) return;
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          if (!houder.hasAttribute('open')) return;
          // Het theme sluit zelf; wij zetten daarna alleen de focus terug.
          setTimeout(function () {
            if (!houder.hasAttribute('open')) knop.focus();
          }, 0);
        });
      })();

      /* --------------------------------------------------------------
         Cookie-ingang in de voettekst (13-09, doc 78 sec.16.1).
         De wet eist dat toestemming intrekken net zo makkelijk is als geven, en onze eigen
         privacyverklaring belooft het. Gemeten op DEV 4: Shopify's eigen banner draait en biedt
         window.privacyBanner.showPreferences(); een eigen banner is er niet.
         De knop staat in de Liquid op `hidden` en wordt hier pas zichtbaar gemaakt als die functie
         er echt is. Zet de operator de banner uit, dan verschijnt er dus geen dode knop.
         -------------------------------------------------------------- */
      (function () {
        var knoppen = document.querySelectorAll('[data-pd-cookie-prefs]');
        if (!knoppen.length) return;

        function api() {
          if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
            return window.privacyBanner.showPreferences.bind(window.privacyBanner);
          }
          return null;
        }

        function toon() {
          if (!api()) return false;
          knoppen.forEach(function (k) { k.hidden = false; });
          return true;
        }

        // De banner laadt asynchroon; kijk een korte tijd na of hij alsnog verschijnt.
        if (!toon()) {
          var pogingen = 0;
          var tik = setInterval(function () {
            pogingen += 1;
            if (toon() || pogingen > 40) clearInterval(tik);
          }, 250);
        }

        document.addEventListener('click', function (e) {
          var knop = e.target && e.target.closest ? e.target.closest('[data-pd-cookie-prefs]') : null;
          if (!knop) return;
          e.preventDefault();
          var open = api();
          if (open) open();
        });
      })();

    
})();
